export default "__VITE_ASSET__Dq7RgnJt__"